import { render, staticRenderFns } from "./VectorLegend.vue?vue&type=template&id=4f362356&scoped=true"
import script from "./VectorLegend.vue?vue&type=script&lang=ts"
export * from "./VectorLegend.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f362356",
  null
  ,true
)

export default component.exports